import { createStyles, makeStyles } from '@material-ui/core';
import { Navigate, Route, Routes } from 'react-router';
import { ExecutionCenterRoute } from './components/ExecutionCenterPage';
import { IqeProjectsList } from './components/ProjectsList';

const useStyles = makeStyles(() =>
  createStyles({
    '@global': {
      'header + div': {
        display: 'none',
      },
      'header ~ article': {
        padding: '0px !important',
      },
    },
  }),
);

export default function IQeRoutes({ isToolAdmin }: { isToolAdmin: boolean }) {
  useStyles();
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="iqe-projects" replace />} />

        <Route path="iqe-projects">
          <Route
            index
            element={<IqeProjectsList isToolAdmin={isToolAdmin} />}
          />
          <Route
            path=":iqeProjectId"
            element={<ExecutionCenterRoute isToolAdmin={isToolAdmin} />}
          />
          <Route
            path=":iqeProjectId/runs/:runId"
            element={<ExecutionCenterRoute isToolAdmin={isToolAdmin} />}
          />
        </Route>
      </Routes>
    </>
  );
}
